

























































import Vue from 'vue';

import length from '@turf/length';
import simplify from '@turf/simplify';
import lineSliceAlong from '@turf/line-slice-along';
import clone from '@turf/clone';

import { getMapboxData, accessToken } from "@/Api";

import MapMarker from "./MapMarker.vue";
import MapTrack from "./MapTrack.vue";
import HeightCurve from "./HeightCurve.vue";
import MapHeightGenerator from "./MapHeightGenerator.vue";
import LayerView from "./LayerView.vue";
import MapPolygons from "./MapPolygons.vue";
import PanZoomInfo from "./PanZoomInfo.vue";

import { sendResizeEventNextTick, setTrackColor } from "../utils/Utils"
import { CameraProps } from "../utils/Camera"

import screenfull from 'screenfull';


import mapboxgl, { GeoJSONSource, Map, LngLatLike, LngLatBoundsLike, LngLatBounds, CameraOptions, LngLat, Popup, AttributionControl, NavigationControl } from 'mapbox-gl';

import {getKmMarkersAlong, updateMarkerProgress} from "@/Util";
import { FeatureCollection, Feature, Properties, LineString, Point, Geometry, Polygon } from '@turf/helpers';

export default Vue.extend({

	components: {
		MapMarker,
		MapTrack,
		HeightCurve,
		MapHeightGenerator,
		LayerView,
		MapPolygons,
		PanZoomInfo,
	},

	data() {
		return {
			progress: 1,
			progressMode: "",
			dataSet: {} as FeatureCollection,
			/*raceLength: 42.195/2,*/
			initialized: false,
			fullscreen: false,
			startCamera: undefined as CameraOptions|undefined,
			currentArea: "",
			elWidth: 0,
			currentZoom: 0,
			trackId: "45",

			layerGroups: [
				{
					name: "Start- och målområdet",
					cats: ["start", "goal", "info", "shower", "health"],
				},
				{
					name: "Energistationer",
					cats: ["water", "dropbag"],
				},
				{
					name: "Hot spots för publik",
					cats: ["parking", "spectators"],
				},

			],

			layers: [
				{
					name: "Start",
					cat: "start",
					visible: true,
				},
				{
					name: "Mål",
					cat: "goal",
					visible: true,
				},
				{
					name: "Distans",
					cat: "km",
					// anchor: "bottom-right",
					visible: true,
				},
				/*{
					name: "Musik",
					cat: "music",
					visible: true,
				},*/
				{
					name: "Energistation",
					cat: "water",
					visible: true,
				},
				{
					name: "Drop bag",
					cat: "dropbag",
					visible: true,
				},
				{
					name: "Parkering publik",
					cat: "parking",
					visible: true,
				},
				{
					name: "Hot spots för publik",
					cat: "spectators",
					visible: true,
				},
				{
					name: "Dusch",
					cat: "shower",
					visible: true,
				},
				{
					name: "Sjukvård",
					cat: "health",
					visible: true,
				},
				{
					name: "Tävlingsexpedition",
					cat: "info",
					visible: true,
				}

			]
		}
	},

	props: {
		mapboxId: {
			type: String,
			required: true,
		},

		styleId: {
			type: String,
			default: "ck1zajmtg2dmt1cmryuom2zal",
		},
		
		fill: {
			type:Boolean,
		},
	},

	computed: {
		simpleTrackFeature():Feature<LineString> {
			//console.log(JSON.stringify(simplify(this.trackFeature, {tolerance:.0001, highQuality:true})));
			return simplify(this.trackFeature, {tolerance:.0001, highQuality:true});
		},

		trackFeature():Feature<LineString> {
			return this.dataSet.features.find(feature => feature.properties!.type == "track" && feature.properties!.trackId == this.trackId) as Feature<LineString, Properties>
		},

		raceLength():Number {
			return length(this.trackFeature);
		},

		heightData():number[][] {
			return this.trackFeature.properties!.heights;
		},
			

		markers():Feature[] {
			return this.dataSet.features.filter(feature => feature.properties ? feature.properties.type == "marker" : false)
		},

		markersOfType():Function {
			return (type:string):Feature[] => {
				
				if (type == "km")
					return this.kmMarkers;
				
				return this.markers.filter(feature => feature.properties!.cat == type)
			}
		},

		kmMarkers():Feature[] {
			return getKmMarkersAlong(this.trackFeature, 1).features;
		},

		/*
		polygons():Feature<Polygon>[] {
			return this.dataSet.features.filter(feature => feature.geometry!.type == "Polygon") as Feature<Polygon>[];
		},
		*/

		sizeClass() {
			if(this.elWidth > 1200)
				return "size-l";
			else
				return "size-m" //todo: more sizes
		},
	},
	
	provide() {
		const self = this;
		return {
			get $map(){
				return self.$map;
			},
		}
	},

	methods: {
		update() {
		},

		setTrack(trackId) {
			this.trackId = trackId;
			this.zoomTo('all');
		},

		toggleFullscreen() {

			if(screenfull.isEnabled) {
				screenfull.toggle(this.$refs.mapContainer as HTMLElement);
			} else {
				window.open(window.location.origin, "_blank");
			}

		},

		initInteractions() {
			const map = this.$map;
			map.scrollZoom.disable();
			map.touchZoomRotate.disableRotation();

			map.on("wheel", event => {
				if (event.originalEvent.ctrlKey || this.fullscreen) {
					event.originalEvent.preventDefault(); // Prevent chrome/firefox default behavior
					if (!map.scrollZoom.isEnabled()) {
						map.scrollZoom.enable();
					}
				} else {
					//@ts-ignore
					this.$refs.panZoomInfo.show();
					if (map.scrollZoom.isEnabled()) {
						map.scrollZoom.disable();
					}
				}
			});

			//disable dragpan on mobile, enable it again when using mouse...
			map.dragPan.disable();
			map.on("mousemove", e => {
				//@ts-ignore
				if(!map.dragPan.isEnabled())
					map.dragPan.enable();
			});

			//@ts-ignore
			map.touchPitch.disable()
			map.on('touchstart', e => {
				var oe = e.originalEvent;
				if (oe && 'touches' in oe) {
					if (oe.touches.length > 1 || this.fullscreen) {
						oe.stopImmediatePropagation();
						map.dragPan.enable();
						//@ts-ignore
						this.$refs.panZoomInfo.hide();
					} else {
						map.dragPan.disable();
					}
				}
			});

			map.on("touchmove", e => {
				const oe = e.originalEvent;
				if (oe && 'touches' in oe) {
					if (oe.touches.length <= 1 && !this.fullscreen && !map.dragPan.isEnabled()) {
						//@ts-ignore
						this.$refs.panZoomInfo.show(true);
					}
				}
			});
		},

		initMap() {

			if(this.initialized)
				return;

			const map = this.$map;

			// let props = CameraProps.fromMap(map);
			// props.lng -= 1;
			// props.lat -= 4.5;
			// props.zoom += 1;
			// map.jumpTo(props.toCameraOptions());

			// let t = gsap.timeline({
			// 	onUpdate: () => {
			// 		map.jumpTo(props.toCameraOptions());
			// 	},
			// 	onComplete: () => {
			// 		this.toggleInteractions(true);
			// 	},
			// 	paused: true,
			// });
			// t.to(this, {progress: 1, duration:10, delay:0, ease: "sine.inOut"}, "<")
			// t.to(props, {zoom:"-=1", lng:"-=1", lat:"+=4.5", duration:5, ease: "sine.inOut"}, "<")

			this.zoomTo("all", true)
			this.initialized = true;

			// const anim = false;
			// if(anim) {
			// 	const checkPlay = () => {
			// 		if(map.areTilesLoaded()) {
			// 			t.play(0);
			// 			map.off("sourcedata", checkPlay);
			// 		}
			// 	}
			// 	map.on("sourcedata", checkPlay);
			// } else {
			// 	t.progress(1).pause();
			// 	this.toggleInteractions(true);
			// 	this.progress = 1;
			// }

			//this.toggleInteractions(true);
			this.progress = 1;
			

		},

		zoomTo(area:string|Feature<Point>, immediate:boolean = false) {

			let cameraOptions:CameraOptions = {};
			if(typeof area != "string") {
				cameraOptions = {
					center: area.geometry!.coordinates as LngLatLike,
					zoom: 15,
				}
			}
			else if(area == "start" || area == "goal") {
				let f;
				if(area == "start")
					f = this.markers.find(feature => feature.properties!.cat == area && feature.properties!.tracks.includes("84"))
				else
					f = this.markers.find(feature => feature.properties!.cat == area)
				if(f) {
					cameraOptions = {
						center: (f.geometry as Point).coordinates as LngLatLike,
						zoom: area == "start" ? 17 : 18.5,
					}
				}
			} else {

				//check if there's a polygon for this
				const f = this.dataSet.features.find(f => f.properties?.area == area);
				let coordinates:any[];
				if(f)
					coordinates = (f.geometry as Geometry).coordinates[0] as any[];
				else
					coordinates = (this.trackFeature.geometry as LineString).coordinates;
				
				let bounds = coordinates.reduce(function(bounds:any, coord:any) {
					return bounds.extend(coord);
				}, new LngLatBounds(coordinates[0] as LngLatLike, coordinates[0] as LngLatLike));
				
				const top = -window.innerHeight/4.4;
				cameraOptions = this.$map.cameraForBounds(bounds, {
					padding: {top:40, left:20, right:20, bottom: 120}
				}) as CameraOptions;

			}

			cameraOptions.pitch = 0;
			cameraOptions.bearing = 0;

			if(immediate)
				this.$map.jumpTo(cameraOptions);
			else
				this.$map.flyTo(cameraOptions);
			
			if (typeof area == "string")
				this.currentArea = area;
			else
				this.currentArea = "";
		},

		checkLoaded() {
			//console.log("LOADED" , this.$map.loaded() , this.$map.areTilesLoaded() , this.dataSet.features != undefined);
			if(this.$map.loaded() && this.$map.areTilesLoaded() && this.dataSet.features != undefined) {
				this.initMap();
			}
		},

		updateSize() {
			this.elWidth = this.$el.clientWidth;
		},

		setProgress(progress, progressMode) {
			this.progressMode = progressMode || "";
			this.progress = progress;
		},

		updateTrackColor() {
			setTrackColor(`--track-${this.trackId}`);
		},

		markerClicked(marker) {
			this.zoomTo(marker)
		}

	},

	watch: {
		trackId() {
			updateMarkerProgress(this.trackFeature, this.markers as any);
			this.updateTrackColor();
		}
	},

	mounted() {

		getMapboxData(this.mapboxId)
		.then(res => {
			this.dataSet = Object.freeze(res.data);
			updateMarkerProgress(this.trackFeature, this.markers as any);
			this.checkLoaded();
		})

		mapboxgl.accessToken = accessToken;

		let map:Map = new Map({
			container: this.$refs.map as Element,
			style: `mapbox://styles/anderswi/${this.styleId}`,

			pitch: 0,
			zoom: 10,
			antialias: true,
			attributionControl: false,
		})
		.addControl(new AttributionControl({
			compact: true,
			customAttribution: "<a href='https://www.racemaps.se' target='_blank'>racemaps.se</a>",
		}))
		.addControl(new NavigationControl({showCompass:false}));
		this.$map = map;
		this.initInteractions();

		map.on('load', this.checkLoaded );

		map.on("movestart", (evt) => {
			if(evt.originalEvent && evt.originalEvent.type != "resize")
				this.currentArea = "";
		});


		map.on("resize", (evt) => {
			if(this.currentArea != "") {
				this.zoomTo(this.currentArea);
			}
			this.updateSize();
		});

		map.on("zoom", (evt) => {
			this.currentZoom = this.$map.getZoom();
		});

		this.updateSize();
		this.updateTrackColor();
		
		this.progress = 0;

		document.addEventListener("fullscreenchange", (evt) => {
			this.fullscreen = document.fullscreenElement == this.$refs.mapContainer;
			sendResizeEventNextTick();

		});
	},
})
